import { render } from "./PositionForm.vue?vue&type=template&id=38a00d24&scoped=true"
import script from "./PositionForm.vue?vue&type=script&lang=ts"
export * from "./PositionForm.vue?vue&type=script&lang=ts"

import "./PositionForm.vue?vue&type=style&index=0&id=38a00d24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38a00d24"

export default script